import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=1140d3a5&scoped=true&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140d3a5",
  null
  
)

export default component.exports